import { render } from "./EditTableClasses.vue?vue&type=template&id=3e74526b&scoped=true"
import script from "./EditTableClasses.vue?vue&type=script&lang=js"
export * from "./EditTableClasses.vue?vue&type=script&lang=js"

import "./EditTableClasses.vue?vue&type=style&index=0&id=3e74526b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e74526b"]])

export default __exports__